<template>
  <div class="Input">
    <span class="label" :style="{ width: labelWidth || '80px' }" v-if="label">
      {{ label }}</span
    >
    <div class="input_box">
      <div class="input_boxcross">
        <input
          v-model="col"
          :placeholder="placeholder"
          :type="type"
          v-bind="$attrs"
          :readonly="readonly"
          @input="
            (e) => {
              handleinput(e);
            }
          "
          :disabled="disabled"
          :maxlength="maxlength"
          ref="Field"
        />
        <van-icon v-show="isDelete" @click="clickDelete" class="cross" name="cross" />
      </div>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </div>
    <div class="SelectInput">
      <div
        v-for="e in suggestList"
        class="suggestList"
        :key="e.openBankNo"
        @click="handleSuggest(e)"
      >
        <div class="suggestName" v-html="e.openBankName.replace(new RegExp(`${col}`), `<span style='color:#F56446; font-size: 14px;'>${col}</span>`)">
        </div>
        <div class="suggestno">{{ e.openBankNo }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Schema from 'async-validator';

export default {
  name: 'Input',
  props: [
    'props',
    'placeholder',
    'reg',
    'maxlength',
    'type',
    'disabled',
    'value',
    'label',
    'labelWidth',
    'border',
    'prop',
    'separate',
    'readonly',
    'toUpperCase',
  ],
  data() {
    return {
      col: '',
      errorMessage: '',
      isDelete: false,
      suggestList: [],
      flag: false,
    };
  },
  computed: {
    isSelectInput() {
      return this.flag && this.col;
    },
  },
  watch: {
    col: {
      handler(newVal, oldVal) {
        if (oldVal === undefined) {
          this.col = this.value;
        }
        if (newVal !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.readonly ? (this.isDelete = true) : '';
        } else {
          this.isDelete = false;
        }
        this.$emit('input', newVal);
      },
      immediate: true,
    }
  },
  mounted() {
    window.document.getElementById('app').addEventListener('click', () => {
      this.flag = false;
      this.suggestList = [];
    });
  },
  methods: {
    debounce(fn, delay) {
      if (this.time !== null) {
        clearTimeout(this.time);
      }
      this.time = setTimeout(() => {
        fn.call(this);
      }, delay);
    },
    handleinput(e) {
      if (e.target.value !== '') {
        this.debounce(async () => {
          this.getSuggest();
        }, 1000);
      } else {
        this.flag = false;
        this.suggestList = [];
      }
    },
    clickDelete() {
      this.col = '';
    },
    // 输入匹配
    async getSuggest() {
      if (this.col === '') return;
      try {
        const { data } = await this.$api.OtherPage.getBankInfo({
          loanBankName: this.col,
        });
        if (data.openBankName) { // 接口有值情况下再赋值，避免接口异步返回赋值异常
          this.suggestList = new Array().concat(data);
        }
        this.flag = true;
      } catch(e) {
      }
    },
    handleSuggest(e) {
      this.col = e.openBankName;
      this.$emit('getOpenBankInfo', e);
      this.flag = false;
      this.suggestList = [];
    },
  },
};
</script>
<style scoped>
.Input {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  position: relative;
}
input {
  width: 70%;
  border: 0;
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.label {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  display: flex;
  align-items: center;
}
.error-message {
  color: #ee0a24;
  font-size: 12px;
  text-align: left;
}
.input_box {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}
.input_boxcross {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.cross {
  color: #9e9fa0;
}
/* .Input >>> input::-webkit-input-placeholder {
  color: #9e9fa0;
}
.Input >>> input::-moz-input-placeholder {
  color: #9e9fa0;
}
.Input >>> input::-ms-input-placeholder {
  color: #9e9fa0;
} */
input:disabled {
  background-color: #fff !important;
}
.SelectInput {
  position: absolute;
  left: 0;
  top: 40px;
  z-index: 2;
  width: 100%;
  max-height: 300px;
  background: #fff;
  overflow: scroll;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
}
.suggestName {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #7c8693;
}
.suggestno {
  font-family: PingFangSC-Regular;
  color: #b9b9b9;
  letter-spacing: 0;
  font-size: 12px;
}
.suggestList {
  padding: 8px;
  border-bottom: 1px solid #eee;
  text-align: left;
}
.suggestList:active {
  background: #eee;
}
.select {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #f55646;
}
</style>
